import type { ReactNode } from 'react';
import { Button } from '@/components/Button';
import { Chip } from '@heroui/react';

/** A left-aligned list row built on the app's HeroUI Button adapter. */
export function ActionRow(props: {
  icon: ReactNode;
  label: string;
  onClick?: () => void;
  danger?: boolean;
  disabled?: boolean;
  badge?: string;
}) {
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={props.onClick}
      disabled={props.disabled}
      leftIcon={<span className="grid w-4 shrink-0 place-items-center">{props.icon}</span>}
      rightIcon={
        props.badge ? (
          <Chip size="sm" variant="soft" className="shrink-0">
            {props.badge}
          </Chip>
        ) : undefined
      }
      className={'w-full justify-start gap-2.5 ' + (props.danger ? 'app-profile-action-danger' : '')}
    >
      <span className="min-w-0 flex-1 truncate text-left">{props.label}</span>
    </Button>
  );
}
